import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

interface GalleryHeaderProps {
  title: string;
  category?: string;
  date?: string;
  description?: string;
}

export const GalleryHeader: React.FC<GalleryHeaderProps> = ({
  title,
  description,
}) => {
  return (
    <Box sx={{ m: 0, position: "relative", zIndex: 100 }}>
      {/* Back Button - Left aligned, above heading */}
      <Box
        component={Link}
        to="/galleries"
        sx={{
          mb: { xs: 0.5, md: 1 },
          mt: 0,
          m: 0,
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          cursor: "pointer",
          textDecoration: "none",
          color: "text.primary",
          position: "relative",
          zIndex: 100,
          pointerEvents: "auto",
          "&:hover": {
            opacity: 0.7,
          },
        }}
      >
        <ArrowBackIcon sx={{ fontSize: { xs: "18px", md: "20px" }, mr: { xs: 0.5, md: 1 } }} />
        <Typography
          variant="body2"
          sx={{
            fontSize: { xs: "0.875rem", md: "1rem" },
            fontFamily: '"Playfair Display", serif',
            fontWeight: 400,
          }}
        >
          Back to Galleries
        </Typography>
      </Box>

      {/* Gallery Title - Centered */}
      <Typography
        variant="h1"
        sx={{
          fontFamily: '"Cinzel Decorative", serif',
          fontSize: { xs: "2rem", sm: "2.5rem", md: "3.5rem", lg: "4rem" },
          fontWeight: 400,
          mb: { xs: 1, md: 1.5 },
          letterSpacing: "-0.02em",
          lineHeight: 1.1,
          textAlign: "center",
        }}
      >
        {title}
      </Typography>

      {/* Description - Italicized Playfair Display, Centered */}
      {description && (
        <Typography
          variant="body1"
          sx={{
            maxWidth: { xs: "100%", md: "800px" },
            mx: "auto",
            color: "text.secondary",
            lineHeight: { xs: 1.6, md: 1.7 },
            fontSize: { xs: "1rem", md: "1.125rem" },
            fontFamily: '"Playfair Display", serif',
            fontStyle: "italic",
            textAlign: "center",
            mb: { xs: 1.5, md: 2 },
          }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};
